import { gql } from '@apollo/client'

export const GET_CUSTOMER_CLV_QUERY = gql`
  query GetCustomerClv($customerId: String!) {
    customer(customerNo: $customerId) {
      id
      performance {
        id
        historicalProfitClvSatangs
        historicalRevenueClvSatangs
        predictedClvSatangs
        predictedClvCalculatedAt

        clvSegment
        clvSegmentChangedAt

        firstPaidAt
        lastPaidAt
        customerLifespanDays
        averageOrderValueSatangs
        averageOrderYieldSatangs
        avgDaysBetweenOrders
        daysSinceLastOrder
        lifetimeMarginPercent

        totalOrderCount
        completeOrderCount
        conversionRate
        cancelledOrderCount
        cancellationRatePercent
        completeOrderAvgLeadTimeDays

        refundedOrderCount
        refundedRevenueSatangs
        refundedYieldSatangs
        refundRatePercent

        lifetimeLogisticsCostSatangs
        voucherRedeemedCount
        voucherRevenueSharePercent
        lifetimeDiscountSatangs
        staffTouchCount
        staffTouchLastAt

        cartAbandonmentCount
        lastCartAbandonedAt
        walletBalanceSatangs
        distinctCategoryCount
        primaryCategorySharePercent
        primaryCategory {
          id
          name
        }
        seasonalityIndex
        heavyComputedAt

        companyCount
        projectCount
        largestOrderValueSatangs
      }
    }
  }
`
